import { useGlobal } from '@/utils/useGlobal';
import AirConditioner from '@elem/SVGIcon/PowerBackup/AirConditioner';
import CofferMaker from '@elem/SVGIcon/PowerBackup/CoffeeMaker';
import ElectricBlanket from '@elem/SVGIcon/PowerBackup/ElectricBlanket';
import ElectricGrill from '@elem/SVGIcon/PowerBackup/ElectricGrill';
import Light from '@elem/SVGIcon/PowerBackup/Light';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import Phone from '@elem/SVGIcon/PowerBackup/Phone';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';

export const useUsCaConfig = (locale: string) => {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    const cards = [
        {
            img: ``,
            power: '1024Wh I 1800W I 2600W X-Boost',
            title: 'EcoFlow DELTA 3 Plus',
            tag: t('common_card_tag_hot_sale'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329',
                    ca: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station?variant=51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7289136054345',
                    ca: '8331157766298',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41826182496329',
                    ca: '51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['<10ms UPS', 'fully charged in 1 hour', 'Expands up to 5kWh'],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: <span className="s-text">4 days</span>,
                    desc: 'Light 10W',
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: <span className="s-text">89 charges</span>,
                    desc: 'Phone 11Wh',
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: <span className="s-text">0.6-1.3 days</span>,
                    desc: 'Car fridge 60W',
                },
                {
                    icon: <CofferMaker className="card-icon" />,
                    title: <span className="s-text">0.8 hr</span>,
                    desc: 'Coffee maker1000W',
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: <span className="s-text">0.6 hr</span>,
                    desc: 'Microwave1300W',
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: <span className="s-text">0.4 hr</span>,
                    desc: 'Air conditioner1000W',
                },
            ],
        },
        {
            img: ``,
            power: '1024Wh I 1800W I 2200W X-Boost',
            title: 'EcoFlow DELTA 2',
            tag: '',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-portable-power-station?variant=40569176358985',
                    ca: 'http://ca.ecoflow.com/products/delta-2-portable-power-station?variant=43725896056986',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7289136054345',
                    ca: '7440912384154',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40569176358985',
                    ca: '43725896056986',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['15 outputs', 'Expands up to 3kWh', '4000 cycles to 80%'],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: <span className="s-text">4 days</span>,
                    desc: 'Light 10W',
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: <span className="s-text">89 charges</span>,
                    desc: 'Phone 11Wh',
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: <span className="s-text">0.6-1.3 days</span>,
                    desc: 'Car fridge 60W',
                },
                {
                    icon: <CofferMaker className="card-icon" />,
                    title: <span className="s-text">0.8 hr</span>,
                    desc: 'Coffee maker1000W',
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: <span className="s-text">0.6 hr</span>,
                    desc: 'Microwave1300W',
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: <span className="s-text">0.4 hr</span>,
                    desc: 'Air conditioner1000W',
                },
            ],
        },
        {
            img: ``,
            power: '2048Wh I 2400W I 3400W X-Boost',
            title: 'EcoFlow DELTA 2 Max',
            tag: t('common_card_tag_hot_sale'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40538145095753',
                    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['Expands up to 6kWh', 'Powerful 3400W AC', 'Durable for 10 years'],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: <span className="s-text">7.3 days</span>,
                    desc: 'Light 10W',
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: <span className="s-text">143 charges</span>,
                    desc: 'Phone 11Wh',
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: <span className="s-text">1.2 days</span>,
                    desc: 'Car fridge 60W',
                },
                {
                    icon: <CofferMaker className="card-icon" />,
                    title: <span className="s-text">1.6 hr</span>,
                    desc: 'Coffee maker1000W',
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: <span className="s-text">1.3 hr</span>,
                    desc: 'Microwave1300W',
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: <span className="s-text">0.9 hr</span>,
                    desc: 'Air conditioner1000W',
                },
            ],
        },
        {
            img: ``,
            power: '3600Wh | 3600W | 4500W X-Boost',
            title: 'EcoFlow DELTA Pro',
            tag: t('common_card_tag_best_seller'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                '3.6-25kWh expandable capacity with DELTA Pro Smart Extra Battery',
                'Delivers 3.6kW-7.2kW for 99% appliances.',
                '0-100% in as fast as 2.8 hours via solar (1.6kW) and in 1.7 hours via EV charging.',
            ],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: <span className="s-text">12 days</span>,
                    desc: 'Light 10W',
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: <span className="s-text">2 days</span>,
                    desc: 'Car fridge 60W',
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: <span className="s-text">261 hrs</span>,
                    desc: 'Phone 11Wh',
                },

                {
                    icon: <ElectricBlanket className="card-icon" />,
                    title: <span className="s-text">1 days</span>,
                    desc: 'Electric blanket 120W',
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: <span className="s-text">2.5 hrs</span>,
                    desc: 'Electric grill 1150W',
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: <span className="s-text">1.6 hrs</span>,
                    desc: 'Air conditioner 1800W',
                },
            ],
        },
        {
            img: ``,
            power: '4kWh | 4000W | 6000W X-Boost',
            title: 'EcoFlow DELTA Pro 3 ',
            tag: '',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                    ca: 'https://ca.ecoflow.com/products/delta-3-portable-power-station?variant=52389663605107',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '15047267156339',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '52389663605107',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['4-48kWh, from 1 day to week of home power ', 'Continuous 120/240V, 4000 output while charging', '80% capacity after 4000 cycles'],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: <span className="s-text">13.6 days</span>,
                    desc: 'Light 10W',
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: <span className="s-text">2.2 days</span>,
                    desc: 'Car fridge 60W',
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: <span className="s-text">297.9 charges</span>,
                    desc: 'Phone 11Wh',
                },

                {
                    icon: <ElectricBlanket className="card-icon" />,
                    title: <span className="s-text">27.3 hrs</span>,
                    desc: 'Electric blanket 120W',
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: <span className="s-text">2.8 hrs</span>,
                    desc: 'Electric grill 1150W',
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: <span className="s-text">1.8 hrs</span>,
                    desc: 'Air conditioner 1800W',
                },
            ],
        },
    ];
    const euCards = [
        {
            img: ``,
            power: t('secF_card1_power'),
            title: t('secF_card1_title'),
            tag: t('common_card_tag_hot_pale'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-3-series-portable-power-station?variant=49573797626199',
                    uk: 'https://uk.ecoflow.com/products/delta-3-series-portable-power-station?variant=49833569026387',
                    de: 'https://de.ecoflow.com/products/delta-3-series-portable-power-station?variant=53707200037199',
                    fr: 'https://fr.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526901899611',
                    it: 'https://it.ecoflow.com/products/delta-3-series-portable-power-station?variant=54819109339512',
                    es: 'https://es.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526969172315',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '9744704930135',
                    uk: '9616877420883',
                    de: '14848608960847',
                    fr: '9594942095707',
                    it: '14845588341112',
                    es: '9594953924955',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '49573797626199',
                    uk: '49833569026387',
                    de: '53707200037199',
                    fr: '49526901899611',
                    it: '54819109339512',
                    es: '49526969172315',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon6_desc'),
                },
            ],
        },
        {
            img: ``,
            power: t('secF_card2_power'),
            title: t('secF_card2_title'),
            tag: '',
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48911033270615',
                    uk: 'https://uk.ecoflow.com/products/delta-pro-3-portable-power-station?variant=49296152723795',
                    de: 'https://de.ecoflow.com/products/delta-pro-3-portable-power-station?variant=49424786358607',
                    fr: 'https://fr.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799611879771',
                    it: 'https://it.ecoflow.com/products/delta-pro-3-portable-power-station?variant=52783177990493',
                    es: 'https://es.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799731024219',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '9488706797911',
                    uk: '9430243180883',
                    de: '9480253407567',
                    fr: '9375271846235',
                    it: '9646835597661',
                    es: '9375312970075',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '48911033270615',
                    uk: '49296152723795',
                    de: '49424786358607',
                    fr: '48799611879771',
                    it: '52783177990493',
                    es: '48799731024219',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon1_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon2_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon3_desc'),
                },
                {
                    icon: <ElectricBlanket className="card-icon" />,
                    title: t.rich('secF_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon4_desc'),
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon6_desc'),
                },
            ],
        },
        {
            img: ``,
            power: t('secF_card3_power'),
            title: t('secF_card3_title'),
            tag: t('common_card_tag_hot_pale'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-2-max-portable-power-station?variant=46790633881943',
                    uk: 'https://uk.ecoflow.com/products/delta-2-max-portable-power-station?variant=46679851139411',
                    de: 'https://de.ecoflow.com/products/delta-2-max-portable-power-station?variant=46739567706447',
                    fr: 'https://fr.ecoflow.com/products/delta-2-max-portable-power-station?variant=46793751789915',
                    it: 'https://it.ecoflow.com/products/delta-2-max-portable-power-station?variant=46891073274205',
                    es: 'https://es.ecoflow.com/products/delta-2-max-portable-power-station?variant=46787970269531',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '8414996627799',
                    uk: '8416984367443',
                    de: '8513034813775',
                    fr: '8431233794395',
                    it: '8415773360477',
                    es: '8435033899355',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '46790633881943',
                    uk: '46679851139411',
                    de: '46739567706447',
                    fr: '46793751789915',
                    it: '46891073274205',
                    es: '46787970269531',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon6_desc'),
                },
            ],
        },
        {
            img: '',
            power: t('secF_card4_power'),
            title: t('secF_card4_title'),
            tag: t('common_card_tag_best_seller'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-2-portable-power-station?variant=42596003512484',
                    uk: 'https://uk.ecoflow.com/products/delta-2-portable-power-station?variant=43099247608000',
                    de: 'https://de.ecoflow.com/products/delta-2-portable-power-station?variant=43148797739255',
                    fr: 'https://fr.ecoflow.com/products/delta-2-portable-power-station?variant=43231886704866',
                    it: 'https://it.ecoflow.com/products/delta-2-portable-power-station?variant=43166053925105',
                    es: 'https://es.ecoflow.com/products/delta-2-portable-power-station?variant=43293121380574',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '7403706253476',
                    uk: '7335539867840',
                    de: '7742214308087',
                    fr: '7838178017506',
                    it: '7778985246961',
                    es: '7766079799518',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '42596003512484',
                    uk: '43099247608000',
                    de: '43148797739255',
                    fr: '43231886704866',
                    it: '43166053925105',
                    es: '43293121380574',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card4_desc1'), t('secF_card4_desc2'), t('secF_card4_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card4_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card4_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card4_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card4_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card4_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card4_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon6_desc'),
                },
            ],
        },
    ];
    return {
        cards,
        euCards,
    };
};
